module.exports = __webpack_public_path__ + "img/Stars.7407057.svg";